import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from '../internal/cx';
import styles from './EmptyState.module.css';

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Primary call to action (usually a Button). */
  primaryAction?: ReactNode;
  secondaryAction?: ReactNode;
  titleAs?: 'h2' | 'h3' | 'h4' | 'p';
  size?: 'sm' | 'md';
}

export function EmptyState({
  icon,
  title,
  description,
  primaryAction,
  secondaryAction,
  titleAs: Title = 'h3',
  size = 'md',
  className,
  children,
  ...rest
}: EmptyStateProps) {
  return (
    <div className={cx(styles.root, styles[size], className)} {...rest}>
      {icon && (
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      <Title className={styles.title}>{title}</Title>
      {description && <p className={styles.description}>{description}</p>}
      {children}
      {(primaryAction || secondaryAction) && (
        <div className={styles.actions}>
          {primaryAction}
          {secondaryAction}
        </div>
      )}
    </div>
  );
}
